module.exports = __webpack_public_path__ + "static/enrollment-screen-image-a9fb8241705af182763830517f5eea40.png";